import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function CatalogForm() {
  const translate = useTranslate();

  return (
    <Form.Input
      name="name"
      label={translate("catalog.fields.name")}
      required
    />
  )
}
